import PushNotifications from '../PushNotifications';

let instance: PushNotifications | null = null;

export function setPushNotificationsInstance(pushInstance: PushNotifications): void {
	instance = pushInstance;
}

export function getPushNotificationsInstance(): PushNotifications {
	if (!instance) {
		throw new Error('PushNotifications instance has not been set yet.');
	}
	return instance;
}

const usePushNotifications = (): PushNotifications => {
	return getPushNotificationsInstance();
};

export default usePushNotifications;
